module.exports = __webpack_public_path__ + "static/media/970-x-250.de43e5ee.svg";